import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/metaPixel';

// Fires a Meta Pixel PageView on every SPA route change. The initial PageView
// is fired by loadPixel() on consent, so we skip the first render to avoid a
// duplicate.
const RouteTracker = () => {
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;
